(function () {
    if (!window.location.pathname.match(/\/car-hire\/.+\/.+/g)) return;

    // IE 8 crashes when loading a google map
    if ($('html').is('.ie6, .ie7, .ie8')) {
        return;
    }

    $('.slideshow').PikaChoose({
        showCaption: false,
        autoPlay: false,
    });

    var GMaps = require('gmaps');

    var latitude = $('#latitude').val();
    var longitude = $('#longitude').val();

    var map = new GMaps({
        el: '#gmap',
        lat: latitude,
        lng: longitude,
    });

    map.addMarker({
        lat: latitude,
        lng: longitude,
        title: 'Green Motion',
        icon: '/images/map-pin.png',
    });

    $('.nav.nav-tabs').children().first().children().first().click();

    // Stop video playback when closing a modal
    $('.modal').on('hidden.bs.modal', function () {
        var $target = $('.modal').find('iframe');

        if ($target.length > 0) {
            $target.attr('src', $target.attr('src'));
        }
    });
})();
